import { useEffect, useState, useRef } from "react"
import Switch from 'react-switch'
import axios from '../../../plugins/axios'
import { useTranslation } from 'react-i18next';
import Toast from "../../../plugins/useToast";

import Dropdown from "./Dropdown"

const Hl7Setting = () => {
    const isDataLoaded = useRef(false);  // getData 완료 여부
    const { t } = useTranslation();
    const [mode, setMode] = useState('server')
    const [ip, setIp] = useState('')
    const [port, setPort] = useState('')
    const [sendInterval, setSendInterval] = useState({ label: '10 sec', value: 10 })
    const [status, setStatus] = useState('OFF')

    const intervalArr = [
        { label: `10 ${t('admin.HL7.sec')}`, value: 10 },
        { label: `1 ${t('admin.HL7.min')}`, value: 60 },
        { label: `10 ${t('admin.HL7.min')}`, value: 600 },
        { label: `30 ${t('admin.HL7.min')}`, value: 1800 },
        { label: `1 ${t('admin.HL7.hour')}`, value: 3600 },
        { label: `3 ${t('admin.HL7.hour')}`, value: 10800 },
        { label: `6 ${t('admin.HL7.hour')}`, value: 21600 },
        { label: `12 ${t('admin.HL7.hour')}`, value: 43200 },
        { label: `24 ${t('admin.HL7.hour')}`, value: 86400 }
    ]

    const [dropdownStates, setDropdownStates] = useState({
        interval: false,
    });

    const handleClickDropdown = (type, val) => {
        setDropdownStates(prev => ({
          ...prev,
          [type]: typeof val !== 'undefined' ? false : !prev[type],
        }));
    };

    const getData = async () => {
        try {
            const res = await axios.get(`/hl7/settings`)
            if (res.code != '200') throw res
            setMode(res.data.serverMode? 'server' : 'client')
            //setMode('client')
            setIp(res.data.ipAddress)
            setPort(res.data.port)
            const interval = intervalArr.find(item => item.value === res.data.intervalSeconds)
            if (interval) {
                setSendInterval(interval)
            } else {
                setSendInterval({ label: res.data.sendInterval + ' sec', value: res.data.intervalSeconds })
            }
            setStatus(res.data.status)
            setTimeout(() => {
                isDataLoaded.current = true;
            }, 0);
        } catch (err) {
            console.warn(err)
            setTimeout(() => {
                isDataLoaded.current = true;
            }, 0);
        }
    }

    const saveData = async () => {
        try {
            const res = await axios.put(`/hl7/settings`, {
                serverMode: mode === 'server',
                ipAddress: ip,
                port: port,
                intervalSeconds: sendInterval.value,
                status: status
            })
            if (res.code != '200') throw res

            Toast({ isSuccess: true, msg: t('admin.HL7.SettingsSaved') })
        } catch (err) {
            console.warn(err)
            Toast({ isSuccess: false, msg: t('admin.HL7.SettingsFailed') })
        }
    }

    useEffect(() => {
        if (!isDataLoaded.current) {
            return;
        }
        setIp('')
    },[mode]);

    useEffect(() => {
        getData()
    }, []);

    return (
       <div className="">
            <div className="flex mb-7">
                <div className="">
                    <div className="admin-title">{t('admin.HL7.title')}</div>
                </div>
                <div className="admin-normal-btn save ml-auto w-[100px] text-white" onClick={() => { saveData() }}>{t('admin.save')}</div>
            </div>
            <div className="flex flex-col gap-3">
                <div className="flex items-center">
                    <div className="admin-label">{t('admin.HL7.mode')}</div>
                    <div className="flex items-center">
                        <label className="custom-radio" style={{ marginRight: 40 }}>
                            <input
                                type="radio"
                                checked={mode === 'server'}
                                onChange={() => setMode('server')}
                            />
                            <span className="font-light" style={{ paddingLeft: 32, fontSize: 16 }}>{t('admin.HL7.server')}</span>
                        </label>
                        <label className="custom-radio">
                            <input
                                type="radio"
                                checked={mode === 'client'}
                                onChange={() => setMode('client')}
                            />
                            <span className="font-light" style={{ paddingLeft: 32, fontSize: 16 }}>{t('admin.HL7.client')}</span>
                        </label>
                    </div>
                </div>
                <div className="flex items-center">
                    <div className="admin-label">{t('admin.HL7.serverIp')}</div>
                    <input 
                        className={`${mode === 'server' ? 'text-white/20 bg-[#0D0D0F]/30' : 'text-white'} w-[640px] h-[32px] bg-[#0D0D0F]  px-3`} 
                        style={{  borderRadius: 6, boxShadow: "0px 2px 1px 0px #00000080 inset", boxShadow: "0px -1px 0px 0px #5A5C63 inset" }} 
                        value={ip} 
                        onChange={(e) => { 
                            const filtered = e.target.value.replace(/[^\d.]/g, '');
                            setIp(filtered)
                        }} 
                        maxLength={15}
                        disabled={mode === 'server'}>
                    </input>
                </div>
                <div className="flex items-center">
                    <div className="admin-label">{t('admin.HL7.serverPort')}</div>
                    <input 
                        className={` w-[640px] h-[32px] bg-[#0D0D0F] text-white px-3`} 
                        style={{  borderRadius: 6, boxShadow: "0px 2px 1px 0px #00000080 inset", boxShadow: "0px -1px 0px 0px #5A5C63 inset" }} 
                        value={port}
                        onChange={(e) => {
                            const filtered = e.target.value.replace(/[^\d]/g, '');
                            setPort(filtered);
                        }}
                        maxLength={5}
                    >                        
                    </input>
                </div>
                <div className="flex items-center">
                    <div className="admin-label">{t('admin.HL7.exportInterval')}</div>
                    <Dropdown
                        customWidth={640}
                        type={'hl7-interval'}
                        isShow={dropdownStates.interval}
                        value={sendInterval}
                        valueArr={intervalArr}
                        handleClick={(val) => { handleClickDropdown('interval', val) }}
                        handleValueClick={(val) => { setSendInterval(val) }}
                    />
                </div>
                <div className="flex items-center">
                    <div className="admin-label" style={{ whiteSpace: 'pre-line' }}>{t('admin.HL7.onOff')}</div>
                    <Switch
                        onChange={() => {setStatus(status === 'ON' ? 'OFF' : 'ON')}}
                        checked={status === 'ON'}
                        offColor="#5E5E5E"
                        onColor="#3182F7"
                        checkedIcon={false}
                        uncheckedIcon={false}
                        height={20}
                        width={36}
                        handleDiameter={18}
                    />
                </div>
            </div>
       </div> 
    )
}

export default Hl7Setting